/* Sis You're Crowned For This
   Header additions.

   The header is a web component: its markup lives inside a <template> and is
   cloned into an open shadow root at load. That is why editing the Shopify
   menus does nothing to it. This reaches into the real header the moment it
   hydrates, and stays quiet if the header ever changes shape.

   Two jobs:
   1. Put The Word next to Prayer wall, and into the mobile drawer.
   2. Point the existing account icon at My Crown instead of Shopify's hosted
      account page, so there is one door to her place, not two. */
(function () {
  var CROWN = '/pages/my-crown';

  var DRAWER =
    '<span class="grp">The Word</span>' +
    '<a href="/pages/bible">Read the Bible</a>' +
    '<a href="/pages/bible#syc-plans">Reading plans</a>' +
    '<a href="/pages/bible#syc-yours">Your Word</a>' +
    '<a href="' + CROWN + '">My Crown</a>';

  function place() {
    var host = document.querySelector('syc-block[data-t="syc-t-header"]');
    if (!host || !host.shadowRoot) return false;
    var r = host.shadowRoot;
    if (r.querySelector('[data-syc-word]')) return true;

    var right = r.querySelector('.nav .right');
    if (!right) return false;

    var a = document.createElement('a');
    a.href = '/pages/bible';
    a.className = 'hide-m';
    a.setAttribute('data-syc-word', '');
    a.textContent = 'The Word';
    if (location.pathname.indexOf('/pages/bible') === 0) a.className = 'hide-m on';
    right.insertBefore(a, right.firstChild);

    /* One account entry point. Repoint hers rather than adding a second. */
    var acct = r.querySelectorAll('a[href="/account"], a[href^="/account?"]');
    for (var i = 0; i < acct.length; i++) {
      acct[i].setAttribute('href', CROWN);
      acct[i].setAttribute('aria-label', 'My Crown');
      acct[i].setAttribute('title', 'My Crown');
    }

    var drawer = r.querySelector('.drawer');
    var firstGroup = drawer && drawer.querySelector('.grp');
    if (firstGroup) {
      var wrap = document.createElement('div');
      wrap.setAttribute('data-syc-word', '');
      wrap.style.display = 'contents';
      wrap.innerHTML = DRAWER;
      firstGroup.parentNode.insertBefore(wrap, firstGroup);
    }
    return true;
  }

  if (place()) return;
  var tries = 0;
  var t = setInterval(function () {
    if (place() || ++tries > 80) clearInterval(t);
  }, 100);
})();
